import { ServiceData } from '../../service';
import db from '../../index';
import { entityServiceFactory } from '../../entityServiceFactory';

export interface DelayReasonsServiceData extends ServiceData {}
const { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain } =
  entityServiceFactory<DelayReasonsServiceData>(db, 'delayReasonsService');

export { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain };
